<template>
    <div class="w-full">
        <v-select v-model="selection" class="style-chooser" :placeholder="placeholder" :options="options" :multiple="multiple" :close-on-select="!multiple" :clear-search-on-select="!multiple" :clearable="clearable">
            <div slot="no-options">Ingen valgmuligheter</div>
        </v-select>
    </div>
</template>

<script>
import LOpenIndicator from "./LOpenIndicator";
import LDeselect from "./LDeselect";
import vSelect from "vue-select";
vSelect.props.components.default = () => ({
    Deselect: LDeselect,
    OpenIndicator: LOpenIndicator
});

export default {
    name: "LLSelect2",
    components: { vSelect },
    props: ["value", "placeholder", "multiple", "options", "clearable"],
    data() {
        return {
            selection: this.value
        };
    },
    methods: {
        selected: function(val) {
            this.$emit("input", val);
            this.selection = val;
        }
    },
    watch: {
        value: function(val) {
            this.selection = val;
        },
        selection: function(val) {
            this.$emit("input", val);
        }
    }
};
</script>




<style src="vue-select/dist/vue-select.css"></style>
<style lang="postcss">
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
    @apply text-xs text-bluegray-300;
}

.style-chooser .vs__dropdown-option {
    @apply text-xs text-bluegray-300;
}

.style-chooser .vs__dropdown-option--highlight {
    @apply bg-pastel-green-500 text-white;
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
    @apply text-gray-500 text-xs;
}

.style-chooser .vs__deselect {
    @apply text-gray-500 text-3xs;
}
</style>